import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n"; // Initialize i18n
import "./lib/apiAuth"; // P0.3: attache X-Session-Token à toutes les requêtes API (axios + fetch)
import "./hooks/useTheme"; // Mode sombre retiré : force le thème clair et nettoie la préférence stockée
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
